module.exports = __webpack_public_path__ + "img/clipboard-plus.83f7f96f.svg";